angular.module('app').controller('LeadsCtrl', function($controller, $scope, $http, $timeout, appUtils, tagService) {
    "ngInject";

    var main = this;
    main.goals = [];
    main.today = new Date();
    main.goal_start = moment().startOf('week').subtract(14, 'days').toDate()


    main.name = 'school';
    angular.extend(main, $controller('ListCtrl', {'$scope': $scope, 'main': main}));
    main.query.order = '-score';
    main.query.is_lead = true;
    main.eqFields.push({'remoteName': 'is_lead', 'localName': 'is_lead'})
    main.query.score = ['Target School','Prospect','No','Imported Master List','Booked'];

    main.toggleStatus = function(status) {
        var idx = main.query.score.indexOf(status);
        if (idx > -1) {
            main.query.score.splice(idx, 1);
        } else {
            main.query.score.push(status);
        }
    }
    
    main.loadGoals = function() {
        console.log(main.goal_start);
        $http.get('/api/v1/admin/todo_goal', {'params': {'start': main.goal_start}}).then(function(response) {
            main.goals = response.data.objects; 
            var startOfWeek = moment().startOf('week')
            main.goals.forEach((goal) => {
                goal.end = moment(goal.start).add(6, 'days').toDate();
                goal.isCurrentWeek = startOfWeek.isSame(moment(goal.start));

                if(goal.isCurrentWeek) {
                    main.scorecardData = {
                        'Pop In': { goal: goal.pop_ins, current: goal.actual_pop_ins },
                        'Touch': { goal: goal.touches, current: goal.actual_touches },
                        'Meetings': { goal: goal.meetings, current: goal.actual_meetings },
                        'Booked': { goal: goal.booked, current: goal.actual_booked }
                    };
                }
            });
        }).catch(function(error) {
            console.error('Error loading goals:', error);
        });
    };

    main.changeGoalDate  = function(change) {
        main.goal_start = moment(main.goal_start).add(change, 'days').toDate();
        main.loadGoals();
    }

    main.metricToKey = function(metric) {
        return metric.toLocaleLowerCase().replace(' ', '_');
    }

    main.updateGoal = function(week, metric) {
        var data = {
            'franchise_id': week.franchise_id
        }
        data[metric] = week[metric];

        $http.put('/api/v1/admin/todo_goal/' + week.id, data).then(function(response) {
        }).catch(function(error) {
            console.error('Error updating todo:', error);
        });
    };
    
    // Load todos on initialization
    main.loadGoals();

    main.actions = [];

    main.todo_query = {
        'results_per_page': 10000,
        'page': 1,
        'order': 'score',
        'q': {
            'filters': []
        }
    }
    
    // Load todos from API
    main.loadTodos = function() {
        $http.get('/api/v1/admin/todo?results_per_page=10000').then(function(response) {
            main.actions = response.data.objects; 
        }).catch(function(error) {
            console.error('Error loading todos:', error);
        });
    };
    
    // Load todos on initialization
    main.loadTodos();

    main.newAction = {
        date_due: new Date(),
    };

    main.saveAction = function(action) {
        var data = angular.copy(action);
        delete data.editing;
        delete data.franchise;

        if(data.done && !data.date_completed) {
            data.date_completed = new Date();
        }

        $http.put('/api/v1/admin/todo/' + action.id, data).then(function(response) {
            action.editing = false;
            main.highlightedActionId = action.id
            main.loadGoals();

            $timeout(function() {
                main.highlightedActionId = null;
            }, 900);
        }).catch(function(error) {
            console.error('Error updating todo:', error);
        });
    };

    main.addNewAction = function() {
        if (main.newAction.action && main.newAction.school) {

            if(main.newAction.done) {
                main.newAction.date_completed = main.newAction.date_due;
            }

            $http.post('/api/v1/admin/todo', main.newAction).then(function(response) {
                main.actions.push(response.data);
                main.loadGoals();
                main.highlightedActionId = response.data.id;

                $timeout(function() {
                    main.highlightedActionId = null;
                }, 900);
                
                main.newAction = {
                    date_due: new Date(),
                };
            }).catch(function(error) {
                console.error('Error creating todo:', error);
            });
        }
    };

    main.actionOptions = ['Pop In', 'Mail', 'Call', 'Email', 'Meeting', 'Booked', 'Social Media'];

    main.mapLeads = function() {
        main.items.forEach(function(lead) {
            if (lead.todos && lead.todos.length > 0) {
                // Sort todos by created_at in descending order and get the first one
                var sortedTodos = lead.todos.slice().sort(function(a, b) {
                    return new Date(b.created_at) - new Date(a.created_at);
                });
                lead.lastAction = sortedTodos[0];
            }
        });
    };
    $scope.$on('items-loaded', main.mapLeads);

    main.searchLeads = function(searchText) {
        var params = appUtils.emptyQuery()
        return appUtils.search('school', searchText, params)
    }

    main.saveLead = function(lead) {
        var data = {'score': lead.score, 'franchise_id': lead.franchise.id};
        $http.put('/api/v1/admin/school/' + lead.id, data).then(function(response) {
        }).catch(function(error) {
            console.error('Error updating lead:', error);
        });
    };

    main.tagFilter = [];
    main.query.tag_ids = [];

    main.searchTags = tagService.search;
    main.transformChip = tagService.transformChip;
    tagService.load();

    main.onTagFilterChange = function() {
        main.query.tag_ids = (main.tagFilter || []).filter(function(t) {
            return t && t.id;
        }).map(function(t) { return t.id; });
    };

    var _baseLeadsPrepareQuery = main.prepareQuery;
    main.prepareQuery = function(query, eqFields) {
        var params = _baseLeadsPrepareQuery(query, eqFields);
        var ids = (main.query.tag_ids || []).filter(function(v) { return v != null; });
        if (ids.length > 0) {
            params.q.filters.push({'name': 'tag_ids', 'op': 'in', 'val': ids});
        }
        return params;
    };

    main.saveLeadTags = function(lead) {
        tagService.ensurePersisted(lead.tags).then(function() {
            var data = {
                'tags': lead.tags,
                'franchise_id': lead.franchise.id
            };
            return $http.put('/api/v1/admin/school/' + lead.id, data);
        }).catch(function(error) {
            console.error('Error saving lead tags:', error);
        });
    };

    main.getPercentage = function(current, goal) {
        if (goal === 0) return 0;
        return Math.min(100, Math.round((current / goal) * 100));
    };

    main.highlightedActionId = null;
    
    $scope.$watch(function() {
        return main.newAction.date;
    }, function(newDate) {
        if (newDate) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var selectedDate = new Date(newDate);
            selectedDate.setHours(0, 0, 0, 0);
            
            // If selected date is in the past, check the done checkbox
            if (selectedDate < today) {
                main.newAction.done = true;
            }
        }
    });

    main.getActionStatus = function(action) {
        var classes ={
            'action-highlight': action.id == main.highlightedActionId
        }
        if (action.done) {
            classes['action-done'] = true;
            return classes;
        }
        
        var today = moment().startOf('day');
        var actionDate = moment(action.date_due).startOf('day');
        
        var daysDiff = actionDate.diff(today, 'days');
        
        if (daysDiff < 0) {
            classes['action-overdue'] = true;
        } else if (daysDiff <= 3) {
            classes['action-due-soon'] = true;
        }
        
        return classes
    };

    main.sortActions = function(action) {
        var timestamp = new Date(action.date_due).getTime();
        if (action.done) {
            var completedTime = action.date_completed ? new Date(action.date_completed).getTime() : timestamp;
            return 1000000000000000 - completedTime;
        } else {
            return timestamp;
        }
    };
});